///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.invitations = abcsetup.thoughtspot.invitations || {};
abcsetup.thoughtspot.invitations.edit = abcsetup.thoughtspot.invitations.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.invitations.edit = {
    init() {
        abcsetup.setTitle('Edit an Invitation');

        abcsetup.thoughtspot.invitations.common.init();
    },
}
